import { Component, Input, OnInit } from '@angular/core';
import { IApplication } from '../../models/application.model';
import { IApplicationFormData } from '../../models/application-form-data.model';

@Component({
  selector: 'irembogov-application-summary',
  templateUrl: './application-summary.component.html',
  styleUrls: ['./application-summary.component.scss'],
})
export class ApplicationSummaryComponent implements OnInit {
  @Input() application?: IApplication;
  @Input() applicationBaseUrl?: string;
  @Input() applicationPath: string | undefined;
  @Input() isCollapsed = false;
  @Input() showTitle = true;
  @Input() applicationSummary: IApplicationFormData[] = [];
  @Input() applicationOtp: string | undefined;
  nonLoggedInapplicationPath = '/application/v1/file-manager/application/';

  ngOnInit(): void {
    this.applicationSummary = this.applicationSummary.filter(
      x =>
        x.formGroup.length > 0 ||
        (x.isService && x.nestedSections && x.nestedSections.length > 0)
    );
  }

  trackByFn(index: number) {
    return index;
  }
}
